export const Divider = () => (
  <div className="mx-3 w-[1.5px] h-7 bg-gray-300"></div>
);
